import { FC, HTMLAttributes } from "react";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import { IOnboardingSlide } from "../../../types/onboarding";
import { useStyles } from "./OnboardingSlideCard.style";
import { useTranslation } from "react-i18next";

interface IOnboardingSlideCardProps {
  slide: IOnboardingSlide;
}

export const OnboardingSlideCard: FC<
  IOnboardingSlideCardProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { slide, ...otherProps } = props;

  return (
    <div {...otherProps}>
      <div className={classes.imageContainer}>
        <Image
          src={slide.image.oneX}
          src2x={slide.image.twoX}
          src3x={slide.image.threeX}
        />
      </div>
      <div className={classes.textContainer}>
        <Typography variant={TypographyVariant.HeadingH4Bold}>
          {t(slide.title)}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB4Regular}
          className={classes.description}
        >
          {t(slide.description)}
        </Typography>
      </div>
    </div>
  );
};
